// Canonical fee calculation — must match strike-payer server getPaymentAmounts exactly.
// Formula: strikeFee = floor(amount × percentage / 10000) + base
//          fee       = shouldAddOnFees ? strikeFee : 0
//          total     = amount + fee
//          net       = total − strikeFee

export const getFees = (appliedRevenueFeeSlab) => {
  if (!appliedRevenueFeeSlab) return { feePercentage: 0, baseFee: 0 };
  return {
    feePercentage: appliedRevenueFeeSlab.percentage / 10000,
    baseFee: appliedRevenueFeeSlab.base,
  };
};

export const getPaymentAmounts = (selectedAmount, shouldAddOnFees, appliedRevenueFeeSlab) => {
  const { feePercentage, baseFee } = getFees(appliedRevenueFeeSlab);
  const percentageFee = Math.floor(selectedAmount * feePercentage);
  const feeToApply = percentageFee + baseFee;
  const feeTotal = shouldAddOnFees ? feeToApply : 0;
  const paymentTotal = selectedAmount + feeTotal;
  return {
    paymentTotal: Math.round(paymentTotal),
    tipAmount: Math.round(selectedAmount),
    feeTotal: Math.round(feeTotal),
    feeToApply: Math.round(feeToApply),
  };
};
